import type { Json } from './database.types';

export type ProfileLink = Readonly<{
  label: string;
  url: string;
}>;

export function normalizeProfileLinks(value: string): ProfileLink[] {
  return value
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [label, ...urlParts] = line.split(/\s+/);
      const url = urlParts.join(' ') || label;
      return { label, url };
    });
}

export function profileLinksToText(links: Json): string {
  if (!Array.isArray(links)) {
    return '';
  }

  return links
    .filter((link): link is { label: string; url: string } => {
      if (!link || typeof link !== 'object') {
        return false;
      }
      return (
        'label' in link &&
        'url' in link &&
        typeof link.label === 'string' &&
        typeof link.url === 'string'
      );
    })
    .map((link) => `${link.label} ${link.url}`)
    .join('\n');
}
